import Service from "../../AuthService"

const Billing = {
    getReceivableBySeller(page,data) {
        return Service.get("/receivable-seller?page="+page+
            "&start_date="+data.start_date+
            "&end_date="+data.end_date+
            "&customer_id="+data.customer_id+
            "&sale_id="+data.sale_id
        )
    },
    getReceivableBySellerId(sellerId, params) {
        return Service.get("/receivable-seller/" + sellerId , {
            params: params
        })
    },
    getCustomerFromSale(sale_id){
        return Service.get("receivable_customer_from_sale?sale_id="+sale_id);
    },
};

export default Billing
